export const AuthCredentials = () => {

    const clients = { 
        "LDAP" : {
            clientId: 'app-anonid',
            redirectUri: `${getHostname()}/callback`,
            responseType: 'code',
            scope: 'openid profile email',
            authUrl: 'https://auth.anonid.io/realms/LDAP/protocol/openid-connect/auth',
            baseUrl: 'https://auth.anonid.io/',
            tokenUrl: 'https://auth.anonid.io/realms/LDAP/protocol/openid-connect/token',
            logoutUrl: 'https://auth.anonid.io/realms/LDAP/protocol/openid-connect/logout',
            realm: 'LDAP'
        },
        "CasinosoftUSA" : {
            clientId: 'app-anonid',
            redirectUri: `${getHostname()}/callback`,
            responseType: 'code',
            scope: 'openid profile email',
            authUrl: 'https://auth.anonid.io/realms/CasinosoftUSA/protocol/openid-connect/auth',
            baseUrl: 'https://auth.anonid.io/',
            tokenUrl: 'https://auth.anonid.io/realms/CasinosoftUSA/protocol/openid-connect/token',
            logoutUrl: 'https://auth.anonid.io/realms/CasinosoftUSA/protocol/openid-connect/logout',
            realm: 'CasinosoftUSA'
        },
	"itaia": {
	    clientId: 'itaia',
	    redirectUri: `${getHostname()}/callback`,
	    responseType: 'code',
	    scope: 'openid profile email',
	    authUrl: 'https://auth.anonid.io/realms/itaia/protocol/openid-connect/auth',
	    baseUrl: 'https://auth.anonid.io/',
	    tokenUrl: 'https://auth.anonid.io/realms/itaia/protocol/openid-connect/token',
	    logoutUrl: 'https://auth.anonid.io/realms/itaia/protocol/openid-connect/logout',
	    realm: 'itaia'
	},
	"anonid": {
            clientId: 'app-anonid',
            redirectUri: `${getHostname()}/callback`,
            responseType: 'code',
            scope: 'openid profile email',
            authUrl: 'https://auth.anonid.io/realms/anonid/protocol/openid-connect/auth',
            baseUrl: 'https://auth.anonid.io/',
            tokenUrl: 'https://auth.anonid.io/realms/anonid/protocol/openid-connect/token',
            logoutUrl: 'https://auth.anonid.io/realms/anonid/protocol/openid-connect/logout',
            realm: 'anonid'
        },

        // "LDAP" : {
        //     clientId: 'app-anonid',
        //     redirectUri: `${getHostname()}/callback`,
        //     responseType: 'code',
        //     scope: 'openid profile email',
        //     authUrl: 'http://localhost:8080/realms/LDAP/protocol/openid-connect/auth',
        //     baseUrl: 'http://localhost:8080/',
        //     tokenUrl: 'http://localhost:8080/realms/LDAP/protocol/openid-connect/token',
        //     logoutUrl: 'http://localhost:8080/realms/LDAP/protocol/openid-connect/logout',
        //     realm: 'LDAP'
        // }
    }

    return clients[getClientName()];
}

export const redirectToAuthFacialEndpoint = () => {
    
    const { clientId, redirectUri, responseType, scope, authUrl } = AuthCredentials();
  
    const authEndpoint = `${authUrl}?client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=${responseType}&scope=${encodeURIComponent(scope)}`;
  
    window.location.href = authEndpoint;
};

export const getClientName = () => {
    return localStorage.getItem('client');
}

export const getHostname = () => { 
    return window.location.origin;
}
